import { DataGrid } from '@mui/x-data-grid'
import TableToolbar from './table-toolbar'
import {
  useWorkoutTableColumns,
  useWorkoutTableRows,
} from '../../../providers/tables'

type Props = {}

const WorkoutTable = (props: Props) => {
  const columns = useWorkoutTableColumns()
  const { rows, loading, error } = useWorkoutTableRows()

  return (
    <>
      <DataGrid
        experimentalFeatures={{ newEditingApi: true }}
        components={{ Toolbar: TableToolbar }}
        loading={loading}
        error={error}
        hideFooterSelectedRowCount
        getRowHeight={() => 'auto'}
        getRowId={(row) => row.id}
        pageSize={10}
        rowsPerPageOptions={[10]}
        autoHeight
        columns={columns}
        rows={rows}
      />
    </>
  )
}

export default WorkoutTable
